import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { ISRAEL } from '../state.js';

const STYLE = 'https://tiles.openfreemap.org/styles/dark';

export function createMap(container) {
  const map = new maplibregl.Map({
    container,
    style: STYLE,
    center: ISRAEL.center,
    zoom: ISRAEL.zoom,
    maxBounds: [
      [32.5, 28.5],
      [37.5, 34.5],
    ],
    attributionControl: false,
    pitchWithRotate: false,
    dragRotate: false,
  });
  map.addControl(new maplibregl.AttributionControl({ compact: true }), 'bottom-left');
  map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'bottom-right');
  return map;
}

export function flyToUser(map, lat, lon) {
  map.easeTo({ center: [lon, lat], zoom: Math.max(map.getZoom(), 9), duration: 700 });
}

export function addUserMarker(map, lat, lon) {
  const el = document.createElement('div');
  el.className = 'user-dot';
  const marker = new maplibregl.Marker({ element: el }).setLngLat([lon, lat]).addTo(map);
  return marker;
}
